import PointsTable from "../../components/pointsTable";

export default function PointsTablePage() {
  return <PointsTable />;
}
